module.exports = __webpack_public_path__ + "static/img/new-success.f4b5f0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/new-success.png
// module id = K97u
// module chunks = 1